import { call, put } from '@redux-saga/core/effects';
import { api, notify, formDataBuilder, apiErrorHandler } from 'services';
import {
  CreateVehicleTypeActions as Actions,
  CreateVehicleTypeRequestAction as RequestAction,
} from 'store/ducks/vehicleTypes';

export function* createVehicleTypeRequest(action: any) {
  const { postData, onSuccess, onFailure }: RequestAction = action;
  try {
    const formData = formDataBuilder(postData);
    yield call(api.post, `vehicle-types`, formData);
    onSuccess && onSuccess();
    notify('success', 'Tipo de veículo criado com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
